<template>
  <div class="-home">
    <div class="container card">
      <div class="title-tar">
        <div class="title-big">收益概况</div>
        <router-link class="title-small" to="/statistics/dashboard">查看详情</router-link>
      </div>
      <div class="chart-top">
        <div class="chart-item" style="border-right: none;">
          <div class="chart-item-title">今日支付金额（元）</div>
          <div class="chart-data">
            <div class="chart-data-primary" style="color: #ff4f4f;">{{ todayAmount / 100 }}</div>
            <div class="chart-data-small">
              昨日
              <span style="margin: 0 6px" />
              {{ yesterdayAmount / 100 }}
            </div>
          </div>
        </div>
        <div class="chart-item">
          <div class="chart-item-title">今日支付订单</div>
          <div class="chart-data">
            <div class="chart-data-primary">{{ todayCount }}</div>
            <div class="chart-data-small">
              昨日
              <span style="margin: 0 6px" />
              {{ yesterdayCount }}
            </div>
          </div>
        </div>
      </div>
      <div class="chart-main">
        <ve-line height="360px" :colors="['#FBF2E7', '#DCEBFA']" :legend-visible="false" :data="chartData" :settings="{ area: true }" :grid="{ bottom: 0 }"></ve-line>
      </div>
    </div>

    <div class="container card">
      <div class="title-tar">
        <div class="title-big">订单概况</div>
        <router-link class="title-small" to="/order/list">查看详情</router-link>
      </div>

      <div class="chart-top">
        <div class="chart-item">
          <div class="chart-item-title">待核销订单</div>
          <div class="chart-data-primary" style="color: #ff4f4f;">{{ todoCount }}</div>
        </div>
        <div class="chart-item">
          <div class="chart-item-title">退货维权订单</div>
          <div class="chart-data-primary">{{ returnCount }}</div>
        </div>
      </div>
    </div>

    <div class="container card">
      <div class="title-tar">
        <div class="title-big">店铺用户</div>
        <router-link class="title-small" to="/custom/list">查看详情</router-link>
      </div>

      <div class="chart-top">
        <div class="chart-item">
          <div class="chart-item-title">今日新增</div>
          <div class="chart-data-primary" style="color: #ff4f4f;">{{ userTodayCount }}</div>
        </div>
        <div class="chart-item">
          <div class="chart-item-title">用户总量</div>
          <div class="chart-data-primary">{{ userCount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../service/grpc.js';
import { rpc } from '../../service/index.js';
import { getToken } from '../../service/helper.js';
import VeLine from 'v-charts/lib/line.common';
import moment from 'moment';

const yesterday = () => {
  const temp = moment(new Date()).add(-1, 'days');
  return moment([temp.year(), temp.month(), temp.date()]);
};

export default {
  name: 'Home',
  components: {
    VeLine
  },
  data() {
    return {
      token: getToken(),
      chartData: {
        columns: ['日期', '支付金额', '有效订单数'],
        rows: []
      },
      todayAmount: 0,
      todayCount: 0,
      yesterdayAmount: 0,
      yesterdayCount: 0,
      todoCount: 0,
      returnCount: 0,
      userTodayCount: 0,
      userCount: 0
    };
  },
  async mounted() {
    rpc(
      'StoreStatisticsService.GetOrderDayStatisticsList',
      M('TimeWithToken', {
        token: M('Token', { token: this.token }),
        createdatgreaterthan: yesterday()
          .add(-7, 'days')
          .unix(),
        createdatlessthan: yesterday()
          .add(1, 'days')
          .unix()
      })
    ).then(res => {
      let rows0 = res.orderdaystatisticslistList.map(v => ({
        日期: v.day,
        支付金额: v.paidamount / 100,
        有效订单数: v.count
      }));
      let rows = [];
      for (let b = yesterday().add(-7, 'days'); b.isBefore(yesterday().add(1, 'days')); b.add(1, 'days')) {
        rows.push(
          rows0.find(v => v['日期'] == b.format('YYYY-MM-DD')) || {
            日期: b.format('YYYY-MM-DD'),
            支付金额: 0,
            有效订单数: 0
          }
        );
      }
      this.chartData.rows = rows;
    });

    rpc(
      'StoreStatisticsService.GetOrderStatistics',
      M('StatusListTimeWithToken', {
        token: M('Token', { token: this.token }),
        statuslistList: [1, 2, 3, 4, 12],
        createdatgreaterthan: yesterday()
          .add(1, 'days')
          .unix()
      })
    ).then(res => {
      this.todayCount = res.count;
      this.todayAmount = res.paidamount;
    });

    rpc(
      'StoreStatisticsService.GetOrderStatistics',
      M('StatusListTimeWithToken', {
        token: M('Token', { token: this.token }),
        statuslistList: [1, 2, 3, 4, 12],
        createdatgreaterthan: yesterday().unix(),
        createdatlessthan: yesterday()
          .add(1, 'days')
          .unix()
      })
    ).then(res => {
      this.yesterdayCount = res.count;
      this.yesterdayAmount = res.paidamount;
    });

    rpc(
      'StoreStatisticsService.GetOrderStatistics',
      M('StatusListTimeWithToken', {
        token: M('Token', { token: this.token }),
        statuslistList: [2]
      })
    ).then(res => {
      this.todoCount = res.count;
    });

    rpc(
      'StoreStatisticsService.GetOrderStatistics',
      M('StatusListTimeWithToken', {
        token: M('Token', { token: this.token }),
        statuslistList: [12]
      })
    ).then(res => {
      this.returnCount = res.count;
    });

    rpc(
      'StoreStatisticsService.GetUserStatistics',
      M('TimeWithToken', {
        token: M('Token', { token: this.token }),
        createdatgreaterthan: yesterday()
          .add(1, 'days')
          .unix()
      })
    ).then(res => {
      this.userTodayCount = res.count;
    });

    rpc(
      'StoreStatisticsService.GetUserStatistics',
      M('TimeWithToken', {
        token: M('Token', { token: this.token })
      })
    ).then(res => {
      this.userCount = res.count;
    });
  }
};
</script>

<style scoped>
.card {
  padding-left: 24px;
}

.title-tar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 12px 0 24px;
}
.title-big {
  font-size: 24px;
  color: #333;
  font-weight: 500;
}
.title-small {
  color: #666;
}

.chart-top {
  display: flex;
  align-items: center;
}
.chart-item {
  min-width: 270px;
  color: #999;
  border-right: 1px solid #efefef;
  margin-right: 26px;
}
.chart-item:last-child {
  border-right: none;
}

.chart-item-title {
  font-size: 17px;
  font-weight: 400;
  margin-bottom: 12px;
}
.chart-data {
  display: flex;
  align-items: flex-end;
}
.chart-data-primary {
  font-size: 28px;
  font-weight: 500;
  line-height: 1;
  margin-right: 24px;
  color: #333;
}
.chart-data-small {
  line-height: 1.5;
  font-size: 14px;
  font-weight: 400;
}
</style>
